import { useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { LatestArticlesResponse } from "../../../models/latest-articles-model";
import { LatestBooksType } from "../../../models/latest-books-model";
import { RightSideTrailNewsType, RightSideTrailType } from "../../../models/right-side-trail-model";
import { cleanLatestArticles, retrieveLatestArticles } from "../../../redux/slice/latest-articles-slice";
import { retrieveLatestBooks } from "../../../redux/slice/latest-books-slice";
import { retrieveLatestCourses } from "../../../redux/slice/latest-courses-slice";
import { retrieveLatestEvents } from "../../../redux/slice/latest-events-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

export type detailPageNewsTrailType = {
  trendingNewsData: RightSideTrailNewsType[]
  popularEventsData: RightSideTrailType[]
  featuredLearningData: RightSideTrailType[]
  featuredBooksData: RightSideTrailType[]
}

const NewsTrail = (props: { detailPageNewsTrail?: detailPageNewsTrailType, isDetails?: boolean }) => {
  const dispatch = useAppDispatch()
  const { trendingNewsData } = useSelector((state: RootState) => state.latestArticles)
  const { popularEventsData } = useSelector((state: RootState) => state.latestEvents);
  const { featuredLearningData } = useSelector((state: RootState) => state.latestCourses);
  const { featuredBooksData } = useSelector((state: RootState) => state.latestBooks);
  let numberOfBooks = 2, numberOfCourses = 2, numberOfEvents = 2, numberOfArticles = 2;
  useEffect(() => {
    dispatch(retrieveLatestArticles(numberOfArticles))
    dispatch(retrieveLatestBooks(numberOfBooks))
    dispatch(retrieveLatestCourses(numberOfCourses))
    dispatch(retrieveLatestEvents(numberOfEvents))

    return () => {
      dispatch(cleanLatestArticles());
    };

  }, [dispatch])

  return <>
    {/* Books */}

    {
      (trendingNewsData || props.detailPageNewsTrail?.featuredBooksData[0]?.rightSideItems !== undefined) ? (
        <div className="col-md-12">
          <h3 >
            <a href="/education/books/">{props.isDetails ? 'Books' : 'Featured Books'} &raquo;</a>
          </h3>
        </div>
      ) : null
    }

    {
      (props.detailPageNewsTrail) ? (
        <>
          {
            props.detailPageNewsTrail?.featuredBooksData[0]?.rightSideItems?.map((item, index) => {
              return <div className="row" key={index}>
                <div className="col-md-3 teaserimg" >
                  <img src={item.imageUrl} alt={item.name} loading="lazy" />
                </div>
                <div className="col-md-9 itemlink">
                  <Nav.Link href={`/products/${item.nodeName.toLowerCase()}`}>{item.name}</Nav.Link>
                </div>
              </div>
            })
          }
          <div className="col-md-12 Newsrelink">
            <a href={`/search?searchtype=books&taxonomy=${props.detailPageNewsTrail?.featuredBooksData[0]?.taxonomy}`}>See All Related Books »</a>
          </div>
        </>

      ) : (
        featuredBooksData.map((item, index) => {
          return <div className="row" key={index}>
            <div className="col-md-3 teaserimg" >
              <img src={item.imageUrl} alt={item.name} loading="lazy" />
            </div>
            <div className="col-md-9 itemlink">
              <Nav.Link href={`/products/${item.nodeName.toLowerCase()}`}>{item.name}</Nav.Link>
            </div>
          </div>
        })
      )
    }

    {/* Learning */}

    {
      (trendingNewsData || props.detailPageNewsTrail?.featuredBooksData[0]?.rightSideItems !== undefined) ? (
        <div className="col-md-12">
          <h3 >
            <a href="/education/courses/">{props.isDetails ? 'Learning' : 'Featured Learning'} &raquo;</a>
          </h3>
        </div>
      ) : null
    }

    {
      (props.detailPageNewsTrail) ? (
        <>
          {
            props.detailPageNewsTrail?.featuredLearningData[0]?.rightSideItems?.map((item, index) => {
              return <div className="row" key={index}>
                <div className="col-md-3 teaserimg" >
                  <img src={item.imageUrl} alt={item.name} loading="lazy" />
                </div>
                <div className="col-md-9 itemlink">
                  <Nav.Link href={`/products/${item.nodeName.toLowerCase()}`}>{item.name}</Nav.Link>
                </div>
              </div>
            })
          }
          <div className="col-md-12 Newsrelink">
            <a href={`/search?searchtype=courses&taxonomy=${props.detailPageNewsTrail?.featuredLearningData[0]?.taxonomy}`}>See All Related Learning »</a>
          </div>

        </>
      ) : (
        featuredLearningData.map((item, index) => {
          return <div className="row" key={index}>
            <div className="col-md-3 teaserimg " >
              <img src={item.imageUrl} alt={item.name} loading="lazy" />
            </div>
            <div className="col-md-9 itemlink">
              <Nav.Link href={`/products/${item.nodeName.toLowerCase()}`}>{item.name}</Nav.Link>
            </div>
          </div>
        })
      )
    }

    {/* Popular Events */}
    {
      (trendingNewsData || props.detailPageNewsTrail?.featuredBooksData[0]?.rightSideItems !== undefined) ? (
        <div className="col-md-12">
          <h3 >
            <a href="/events">{props.isDetails ? 'Events' : 'Popular Events'}  &raquo;</a>
          </h3>
        </div>
      ) : null
    }

    {
      (props.detailPageNewsTrail) ? (

        <>
          {
            props.detailPageNewsTrail?.popularEventsData[0]?.rightSideItems?.map((item, index) => {
              return <div className="row" key={index}>
                <div className="col-md-3 teaserimg" >
                  <img src={item.imageUrl} alt={item.name} loading="lazy" />
                </div>
                <div className="col-md-9 itemlink">
                  <Nav.Link href={`/events/${item.nodeName.toLowerCase()}`}>{item.name}</Nav.Link>
                </div>
              </div>
            })
          }
          <div className="col-md-12 Newsrelink">
            <a href={`/search?searchtype=events&taxonomy=${props.detailPageNewsTrail?.popularEventsData[0]?.taxonomy}`}>See All Related Events »</a>
          </div>
        </>
      ) : (
        popularEventsData.map((item, index) => {
          return <div className="row" key={index}>
            <div className="col-md-3 teaserimg" >
              <img src={item.sideImage} alt={item.eventName} loading="lazy" />
            </div>
            <div className="col-md-9 itemlink">
              <Nav.Link href={`/events/${item.nodeName.toLowerCase()}`}>{item.eventName}</Nav.Link>
            </div>
          </div>
        })
      )
    }

    {/* Trending News */}
    {
      (trendingNewsData || props.detailPageNewsTrail?.trendingNewsData[0]?.articlesList !== undefined) ? (
        <h3 >
          <a href="/news-and-articles/">{props.isDetails ? 'News' : 'Trending News'} &raquo;</a>
        </h3>
      ) : null
    }
    {
      (props.detailPageNewsTrail !== undefined) ? (
        <>
          {
            props.detailPageNewsTrail?.trendingNewsData[0]?.articlesList?.map((item, index) => {
              return <div className="row" key={index}>
                <div className="col-md-3 teaserimg " >
                  <img src={item.articleTeaserImage} alt={item.articleName} loading="lazy" />
                </div>
                <div className="col-md-9 itemlink">
                  <Link to={item.articleUrl.toLowerCase()}>{item.articleName}</Link>
                </div>
              </div>
            })
          }
          <div className="col-md-12 Newsrelink">
            <a href={`/search?searchtype=news&taxonomy=${props.detailPageNewsTrail?.trendingNewsData[0]?.taxonomy}`}>See All Related News »</a>
          </div>
        </>


      ) : (
        trendingNewsData.map((item, index) => {
          return <div className="row" key={index}>
            <div className="col-md-3 teaserimg " >
              <img src={item.articleTeaserImage} alt={item.articleName} loading="lazy" />
            </div>
            <div className="col-md-9 itemlink">
              <Link to={item.articleUrl.toLowerCase()}>{item.articleName}</Link>
            </div>
          </div>
        })
      )
    }

    <div className="row">
      <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625083968-0" style={{ width: "300.375px", minWidth: 300, minHeight: 250, margin: "9px auto", padding: "0 .2px" }}></div>
    </div><div className="row">
      <div className="CMSBanner Banner gadsbanner" id="div-gpt-ad-1628625213078-0" style={{ width: "300.375px", minWidth: 300, minHeight: 250, margin: "9px auto", padding: "0 .2px" }}></div>
    </div>

  </>
}

export default NewsTrail;